"use client"

import { ArrowLeft } from "lucide-react"
import Link from "next/link"

import { Badge } from "@/core/ui/badge"
import { Button } from "@/core/ui/button"
import { Card } from "@/core/ui/card"

export function ChatbotView() {
    return (
        <div className="min-h-screen bg-background p-4 md:p-8">
            <div className="mx-auto max-w-4xl space-y-8">

                {/* Header / Nav (Micro-App styles) */}
                <div className="flex items-center justify-between">
                    <Link href="/">
                        <Button variant="ghost" size="sm" className="gap-2">
                            <ArrowLeft className="size-4" />
                            Back to Portfolio
                        </Button>
                    </Link>
                    <Badge variant="outline" className="text-xs uppercase tracking-widest">
                        Lab / Engagement Demo 01
                    </Badge>
                </div>

                {/* Main Content Area */}
                <div className="grid gap-8 md:grid-cols-[1fr_300px]">

                    {/* Chat Area */}
                    <Card className="flex h-[600px] flex-col justify-center border-primary/20 bg-muted/30 p-8 text-center backdrop-blur-xs">
                        <h1 className="mb-2 text-3xl font-bold tracking-tight">AI Assistant Demo</h1>
                        <p className="mb-8 text-muted-foreground">
                            This is a proof-of-concept engagement demo.
                            <br />
                            Implementation coming next.
                        </p>
                        <Button className="mx-auto w-fit">Initialize Connection</Button>
                    </Card>

                    {/* Context / Info Sidebar */}
                    <div className="space-y-4">
                        <Card className="p-4">
                            <h3 className="mb-2 font-semibold">Tech Stack</h3>
                            <ul className="list-inside list-disc text-sm text-muted-foreground">
                                <li>Vercel AI SDK</li>
                                <li>LangChain</li>
                                <li>Python Backend (Mock)</li>
                                <li>Streaming Response</li>
                            </ul>
                        </Card>
                        <Card className="p-4">
                            <h3 className="mb-2 font-semibold">Objective</h3>
                            <p className="text-sm text-muted-foreground">
                                Demonstrate ability to build context-aware RAG systems for enterprise clients.
                            </p>
                        </Card>
                    </div>

                </div>
            </div>
        </div>
    )
}
